import { render, staticRenderFns } from "./educationDetailAdd.vue?vue&type=template&id=b6b33292&scoped=true&"
import script from "./educationDetailAdd.vue?vue&type=script&lang=js&"
export * from "./educationDetailAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b33292",
  null
  
)

export default component.exports